module.exports = __webpack_public_path__ + "static/media/film-production-catering-banner.217d3131.jpg";